// components/import/ImportDevis.js
import React, { useState } from 'react';
import { Button, message, Space, Card, Divider } from 'antd';
import { CloudDownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import axios from 'axios';

const ImportDevis = () => {
  const [loading, setLoading] = useState(false);
  const [forceLoading, setForceLoading] = useState(false);
  const [articlesLoading, setArticlesLoading] = useState(false);
  const [clientsLoading, setClientsLoading] = useState(false);
  const [devisLoading, setDevisLoading] = useState(false);

  const handleImport = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/import/all`
      );
      
      if (response.data.success) {
        message.success('Import completed successfully');
      } else {
        message.error('Import failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Import error:', error);
      message.error('Import failed: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleForceImport = async () => {
    setForceLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/import/force`
      );
      
      if (response.data.success) {
        message.success('Forced import completed successfully');
      } else {
        message.error('Forced import failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Forced import error:', error);
      message.error('Forced import failed: ' + (error.response?.data?.message || error.message));
    } finally {
      setForceLoading(false);
    }
  };

  const handleImportArticles = async () => {
    setArticlesLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/import/articles`
      );
      if (response.data.success) {
        message.success('Articles import completed successfully');
      } else {
        message.error('Articles import failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Articles import error:', error);
      message.error('Articles import failed: ' + (error.response?.data?.message || error.message));
    } finally {
      setArticlesLoading(false);
    }
  };

  const handleImportClients = async () => {
    setClientsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/import/clients`
      );
      if (response.data.success) {
        message.success('Clients import completed successfully');
      } else {
        message.error('Clients import failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Clients import error:', error);
      message.error('Clients import failed: ' + (error.response?.data?.message || error.message));
    } finally {
      setClientsLoading(false);
    }
  };

  const handleImportDevisOnly = async () => {
    setDevisLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/import/devis`
      );
      if (response.data.success) {
        message.success('Devis import completed successfully');
      } else {
        message.error('Devis import failed: ' + response.data.message);
      }
    } catch (error) {
      console.error('Devis import error:', error);
      message.error('Devis import failed: ' + (error.response?.data?.message || error.message));
    } finally {
      setDevisLoading(false);
    }
  };

  return (
    <Card 
      title="Import DBF Files" 
      style={{ maxWidth: 600, margin: '20px auto' }}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <p>
        Import des fichiers (Articles, Clients, Commercial, Familles, Devis).
        Cela mettra à jour votre base de données locale avec les dernières données.
        </p>
        <Button
          type="primary"
          icon={<CloudDownloadOutlined />}
          loading={loading}
          onClick={handleImport}
          size="large"
          block
        >
          {loading ? 'Importation en Cours...' : "Démarrez l'import"}
        </Button>

        <Divider>Importer individuellement</Divider>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            onClick={handleImportArticles}
            loading={articlesLoading}
            block
          >
            {articlesLoading ? 'Import Articles...' : 'Importer Articles seulement'}
          </Button>
          <Button
            onClick={handleImportClients}
            loading={clientsLoading}
            block
          >
            {clientsLoading ? 'Import Clients...' : 'Importer Clients seulement'}
          </Button>
          <Button
            onClick={handleImportDevisOnly}
            loading={devisLoading}
            block
          >
            {devisLoading ? 'Import Devis...' : 'Importer Devis seulement'}
          </Button>
        </Space>
        
        <p style={{ marginTop: '20px' }}>
        Import forcé: Réimporte tous les fichiers en ignorant les vérifications de modification.
        </p>
        <Button
          type="primary"
          danger
          icon={<ReloadOutlined />}
          loading={forceLoading}
          onClick={handleForceImport}
          size="large"
          block
        >
          {forceLoading ? 'Importation Forcée en Cours...' : "Import Forcé"}
        </Button>
      </Space>
    </Card>
  );
};

export default ImportDevis;

